import ButtonView from './button-view'

export default ButtonView
